import setSettingsFromServer from '@/helpers/setSettingsFromServer'
import { useEffect, useState } from 'react'

export const useGetSettings = () => {
  const [settings, setSettings] = useState<Record<string, string> | null>(null)

  useEffect(() => {
    setSettingsFromServer(setSettings)
  }, [])

  const getSettings = (key: string): string | null => {
    return settings?.[key] ?? null
  }

  const checkSettings = (key: string): boolean => {
    return settings?.[key] === '1'
  }

  return { getSettings, checkSettings }
}
